import Header from './Header';
import Auth from '../Reuseable/Auth';
import Notification from '../Home/Components/Notification';
import Tracker from '../Home/Components/Tracker';
import Language from '../Home/Components/Language';

const Layout = () => {
 return (
    <>
    <div className='saddle-custom-header-wrapper'>
      <div className='saddle-header-main-row'>
         <Header/>
        <div className='saddle-header-right-auth'>
           <Auth />
        </div>
      </div>
    </div>
    </>
  )
}
export default Layout;